import type { IdentityProviderPayload } from '@Application/Security/Sso/Actions/identityProviderFetched';

export type IdentityProviderSavedPayload = IdentityProviderPayload;

export type IdentityProviderSavedAction = {
	type: 'IDENTITY_PROVIDER_SAVED';
	payload: IdentityProviderSavedPayload;
	accountId: number;
};

export default (payload: IdentityProviderSavedPayload, accountId: number): IdentityProviderSavedAction => ({
	type: 'IDENTITY_PROVIDER_SAVED',
	payload,
	accountId,
});
